import { Types } from '../actionTypes'

const initialState = {
  isOnline: null,
  idleTime: 0
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_IS_ONLINE:
      return {
        ...state,
        isOnline: action.payload
      }
    case Types.SET_IDLETIME:
      return {
        ...state,
        idleTime: action.payload
      }
    case Types.PUSH_IDLETIME:
      return {
        ...state,
        idleTime: state.idleTime + 1
      }
    default:
      return state
  }
}

export default reducer